import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  redirect(model) {
    if (model.get('sent')) {
      this.router.transitionTo('broadcasts.newsletter.overview.reports');
    } else {
      let { hasRecipients, templatesReadyToSend, validConversion, isScheduled } = model;

      if (hasRecipients && templatesReadyToSend && validConversion) {
        if (isScheduled) {
          this.router.transitionTo('broadcasts.newsletter.setup.review');
        } else {
          this.router.transitionTo('broadcasts.newsletter.setup.review');
        }
      } else {
        this.router.transitionTo('broadcasts.newsletter.setup.recipients');
      }
    }
  }
}
